export const NOT_SET = 'not_set';

/** The fixed categories a recruitment status can be mapped to, in display order. */
export const recruitmentCategoryOptions = () => [
    { value: 'not_started', label: $t('Not started') },
    { value: 'in_market', label: $t('In market') },
    { value: 'offer_stage', label: $t('Offer stage') },
    { value: 'filled', label: $t('Filled') },
];

/** Every reporting bucket, "Not set" first, as the dashboard shows them. */
export const recruitmentSummaryCategories = () => [{ value: NOT_SET, label: $t('Not set') }, ...recruitmentCategoryOptions()];

/** The only colours a status may use. */
export const RECRUITMENT_STATUS_PALETTE = ['#C6C6C7', '#82AEFA', '#4485F8', '#F5A623', '#F4B95B', '#00DD8D', '#008A58', '#8D8E8E'];

/** Dispatched on window after statuses are added, edited, deleted, reordered or restored. */
export const RECRUITMENT_STATUSES_CHANGED_EVENT = 'recruitment-statuses:changed';

/** Dispatched on window after positions' statuses change, so the dashboard tiles refetch. */
export const RECRUITMENT_SUMMARY_STALE_EVENT = 'recruitment-summary:stale';

export const notifyRecruitmentStatusesChanged = () => window.dispatchEvent(new CustomEvent(RECRUITMENT_STATUSES_CHANGED_EVENT));

export const notifyRecruitmentSummaryStale = () => window.dispatchEvent(new CustomEvent(RECRUITMENT_SUMMARY_STALE_EVENT));
